import { Box, Button, Fade, Link, Paper, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";

import { Centered } from "@shoothill/core";
import { EditableInput } from "@shoothill/core";
import { ResetPasswordModel } from "./ResetPasswordModel";
import { ResetPasswordViewModel } from "./ResetPasswordViewModel";
import { runInAction } from "mobx";
import { useObserver } from "mobx-react-lite";

import "./ResetPasswordView.styles.scss";

export const ResetPasswordView: React.FunctionComponent = () => {
    const [viewModel] = useState(() => new ResetPasswordViewModel());
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    useEffect(() => {
        viewModel.getTokenFromUrl();
    }, []);

    const doSubmit = async (e: any) => {
        e.preventDefault();

        if (await viewModel.isModelValid()) {
            runInAction(() => {
                setIsLoading(true);
            });

            const apiResult = await viewModel.resetPasswordAsync();

            runInAction(() => {
                setIsLoading(false);

                if (apiResult) {
                    if (apiResult.wasSuccessful) {
                        setErrorMessage("");
                        setIsSuccess(true);
                    } else {
                        setErrorMessage("* " + apiResult.errors[0].message);
                        setIsSuccess(false);
                    }
                } else {
                    setErrorMessage("* Unknown error has occurred.");
                    setIsSuccess(false);
                }
            });
        }
    };

    const goToForgotPassword = async (e: any) => {
        viewModel.history.push("/forgotpassword");
    };

    const goToLoginPage = async (e: any) => {
        viewModel.history.push("/login");
    };

    return useObserver(() => (
        <div className="reset-password__wrapper">
            <Fade in timeout={1000}>
                <Paper>
                    <div className="reset-password-form__container">
                        {viewModel.tokenValid === true ? (
                            <>
                                {!isSuccess && <p style={{ fontSize: 25, fontWeight: "bold", marginBottom: 10 }}> Reset password</p>}
                                {isSuccess && <p style={{ fontSize: 25, fontWeight: "bold", marginBottom: 10 }}>Success! Your password has been reset.</p>}
                                {!isSuccess && <p style={{ fontSize: 18 }}>Create your new password bellow</p>}
                                <form className="reset-password-form" onSubmit={doSubmit}>
                                    {!isSuccess && (
                                        <>
                                            {errorMessage !== "" && (
                                                <Typography variant="caption" style={{ color: "red" }}>
                                                    {errorMessage}
                                                </Typography>
                                            )}
                                            <EditableInput<ResetPasswordModel>
                                                type="password"
                                                label="New Password"
                                                validateOnBlur={true}
                                                viewModel={viewModel}
                                                fieldName="newPassword"
                                            />
                                            <EditableInput<ResetPasswordModel>
                                                type="password"
                                                label="Confirm Password"
                                                validateOnBlur={true}
                                                viewModel={viewModel}
                                                fieldName="confirmPassword"
                                            />
                                            <Button type="submit" fullWidth variant="contained" color="primary">
                                                {isLoading ? "Please Wait..." : "Reset password"}
                                            </Button>
                                            {errorMessage !== "" && (
                                                <Link
                                                    style={{ fontSize: 14, color: "#4C8CA7", textDecoration: "underline", display: "block", cursor: "pointer" }}
                                                    onClick={goToForgotPassword}
                                                >
                                                    Return to forgot password
                                                </Link>
                                            )}
                                        </>
                                    )}

                                    {isSuccess && (
                                        <Button onClick={goToLoginPage} fullWidth variant="contained" style={{ backgroundColor: "#4C8CA7", color: "white" }}>
                                            Go to login page
                                        </Button>
                                    )}
                                </form>
                            </>
                        ) : viewModel.tokenValid === false ? (
                            <>
                                <Box justifyContent="center" textAlign="center" display="grid" minWidth="300px" maxWidth="300px">
                                    <p style={{ fontSize: 25, fontWeight: "bold", marginBottom: 10 }}> Reset password</p>
                                    <p style={{ fontSize: 18, marginBottom: 20 }}>Create your new password bellow</p>
                                    <Link style={{ fontSize: 14, color: "#4C8CA7", textDecoration: "underline", display: "block", cursor: "pointer" }} onClick={goToForgotPassword}>
                                        Return to forgot password
                                    </Link>
                                </Box>
                            </>
                        ) : (
                            <>
                                <Box justifyContent="center" textAlign="center" display="grid" minWidth="300px" maxWidth="300px">
                                    <p style={{ fontSize: 25, fontWeight: "bold", marginBottom: 10 }}> Reset password</p>
                                    <p style={{ fontSize: 18 }}>Create your new password bellow</p>
                                </Box>
                            </>
                        )}
                    </div>
                </Paper>
            </Fade>
        </div>
    ));
};
